module.exports = __webpack_public_path__ + "img/ugly_or_beuty_techno_kicsi.c93b112d.jpg";